export default "__VITE_ASSET__CISCW_O8__"